import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";

const ToastNotify = () => {
  useEffect(() => {}, []);

  return (
    <ToastContainer
      position="bottom-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable
      pauseOnHover
    />
  );
};

export default ToastNotify;
